__turbopack_context__.v({
  "controlsContainer": "index-module__cCn87W__controlsContainer",
  "imgContainer": "index-module__cCn87W__imgContainer",
  "loading": "index-module__cCn87W__loading",
  "previewAnimation": "index-module__cCn87W__previewAnimation",
  "previewContainer": "index-module__cCn87W__previewContainer",
});
